<template>
  <svg class="icon-checkout" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <circle :fill="bg" fill-rule="nonzero" cx="11" cy="11" r="11"></circle>
      <path
          d="M4.684 11.567a.49.49 0 0 1-.035-.604l.226-.307a.395.395 0 0 1 .555-.079l2.812 2.155a.528.528 0 0 0 .625-.012l7.474-6.227a.444.444 0 0 1 .592.026l.13.129a.39.39 0 0 1 .003.559L8.842 15.3a.388.388 0 0 1-.555-.004l-3.603-3.729z"
          :fill="color"></path>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconCheck",

    props: {
      bg: {
        default: '#4455E4',
        type: String,
      },

      color: {
        default: '#fff',
        type: String,
      },
    },
  }
</script>

<style scoped>
  .icon-checkout {
    width: 0.22rem;
    height: 0.22rem;
  }

</style>